import React, { useState, useEffect } from "react";
import Countdown from "react-countdown";

import { history } from "../../_helpers/history";
import hasApptExpired from "../../_helpers/hasApptExpired";

function countdownRenderer({ hours, minutes, seconds, completed }) {
  return <h6 className="text-center mt-5">This appointment will expire in: {minutes}:{seconds}</h6>;
}

export default function CountdownTime(props) {
  const hour = 3600000;
  const [timeLeft, setTimeLeft] = useState(Date.now() + hour);

  useEffect(() => {
    let expired = hasApptExpired(props.sentAt, props.timezone);
    if (expired !== true) {
      setTimeLeft(expired);
    }
  }, [props]);

  return <Countdown
    date={timeLeft}
    renderer={countdownRenderer}
    onComplete={() => {
        history.push('/');
    }} />;
}
